import { updateFpAppV4Data } from "../../../redux/fpAppV4Slice";
import store from "../../../redux/store";
import fpLog from "../../../utils/fpLog";
import addWorkspaceIdToUrl from "./addWorkspaceIdToUrl";
import updateQueryStatus from "./updateQueryStatus";
import updateFileDetailsInRQ from "@/components/FpFundBrain/Manage/Documents/updateFileDetailsInRQ";
import lockEditor from "./lockEditor";
import useFileTrayStore from "@/components/common/FileTree/UploadStuff/useFileTrayStore";
import { queryClient } from "@/ReactQuery/reactQueryClient";
import useRmsRefreshStore from "@/components/FpPages/RMS/Data/rmsRefreshStore";

const consumeV4WebSocketMessage = (message, options = {}) => {
  try {
    const data = JSON.parse(message.data);
    const updateFile = useFileTrayStore.getState().updateFile;
    if (typeof data.message === "string")
      try {
        data.message = JSON.parse(data.message);
      } catch (error) {
        console.error("Error parsing message", data.message);
      }

    const { message_type: messageType, message_data: messageData } =
      data.message;

    // Get workspace type from Redux store
    const workspaceType = store.getState().fpAppV4Data.type;

    // Filter out certain message types for template workspaces
    // Templates should not receive query execution updates
    if (
      workspaceType === "private_doc_editor_template" ||
      workspaceType === "editor_template"
    ) {
      const templateBlockedMessages = [
        "QUERY_ANSWER_STATUS_UPDATE",
        "V3_QUERY_EXECUTION_STATUS_UPDATE",
        "V3_QUERY_EXECUTION_TOOL_RESPONSE",
        "V3_QUERY_EXECUTION_STREAMING_SEARCH_MERGE_RESPONSE",
        "LOCK_WORKSPACE_EDITOR",
      ];

      if (templateBlockedMessages.includes(messageType)) {
        return;
      }
    }

    if (options && options.callback) {
      options.callback(data.message);
    }

    if (messageType === "QUERY_ANSWER_STATUS_UPDATE") {
      // Filter out messages that don't belong to the current workspace
      const currentWorkspaceId = store.getState().fpAppV4Data.workspaceId;
      if (
        messageData.workspace_id &&
        messageData.workspace_id !== currentWorkspaceId
      ) {
        return;
      }

      if (messageData.status_text) fpLog(messageData.status_text);
      else fpLog(messageData);

      if (messageData) {
        updateQueryStatus(messageData);
      }
    }

    if (messageType === "LOCK_WORKSPACE_EDITOR") {
      lockEditor(1500);
    }

    if (messageType === "WORKSPACE_HISTORY_UPDATE") {
      addWorkspaceIdToUrl();
      store.dispatch(
        updateFpAppV4Data({
          title: messageData.title,
          trigger: "refresh_history",
        })
      );
    }

    // A document's comments changed (#13194): every comments list open on
    // the workspace refetches (useDocumentComments listens for this).
    if (messageType === "WORKSPACE_COMMENTS_UPDATE") {
      window.dispatchEvent(
        new CustomEvent("documentCommentsChanged", {
          detail: { workspaceId: messageData._id },
        })
      );
      // The agent put a thread's mark into the body (PR 2): an editor open on
      // the document reloads it, so its next autosave keeps the mark.
      if (messageData.body_changed) {
        window.dispatchEvent(
          new CustomEvent("editorDocumentRefresh", {
            detail: { workspaceId: messageData._id },
          })
        );
      }
    }

    if (messageType === "AI_FILL_ASSET_SUMMARY") {
      queryClient
        .refetchQueries({
          queryKey: ["asset-details"],
        })
        .then(() => {
          // window.openFpToast(messageData.message, messageData.severity);
        });
    }

    if (messageType === "FILE_UPLOAD_STATUS_UPDATE") {
      // useHandleFileUploadProgress(messageData);
      updateFile(messageData);
      // store.dispatch(
      //   updateFpAppV4Data({
      //     fileUploadStatus: messageData,
      //     file_upload_trigger: "refresh_file_uploads",
      //   })
      // );
    }

    if (messageType === "UNGREY_FILE_UPLOAD") {
      updateFileDetailsInRQ({
        fileId: messageData.blobId,
        status: messageData.status,
      });
    }

    if (messageType === "DOCUMENT_CELLS_UPDATED") {
      useRmsRefreshStore.getState().markNewData();
    }

    if (
      messageType === "SHAREPOINT_SYNC_COMPLETE" ||
      messageType === "ONENOTE_SYNC_COMPLETE"
    ) {
      // Invalidate the file list to show newly synced files
      queryClient.invalidateQueries({ queryKey: ["orgFileList"] });
      const syncType =
        messageType === "SHAREPOINT_SYNC_COMPLETE" ? "SharePoint" : "OneNote";
      const folderPath = messageData.folder_path
        ? messageData.folder_path.join("/")
        : "all folders";
    }
  } catch (error) {}
};

export default consumeV4WebSocketMessage;
